import React, { memo, useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import MapPolygon from '../../MapObjects/MapPolygon';
import MapFieldHole from '../../MapObjects/MapFieldHole';
import { Coordinate, CoordinateObject, PolygonCoordinates, Ring } from '../../../../types/geo';

const mapStoreToProps = (store: any) => ({
  selectedField: store.field.selectedField,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

const SplitField: React.FC<PropsFromRedux> = ({ selectedField }) => {
  const coordinates = useRef<CoordinateObject[]>(
    selectedField.polygon.coordinates[0].map((coord: Coordinate): CoordinateObject => {
      return {
        lng: coord[0],
        lat: coord[1],
      };
    })
  );

  const visibleFieldHoles: PolygonCoordinates = selectedField.polygon.coordinates.slice(1);

  return (
    <>
      <MapPolygon
        fillOpacity={0.0}
        fillColor={'white'}
        strokeColor={'rgb(224,210,61)'}
        strokeWeight={2}
        disabled={true}
        coordinates={coordinates.current}
        selected={false}
        zIndex={0}
      />
      {visibleFieldHoles &&
        visibleFieldHoles.map((boundary: Ring, index: number) => (
          <MapFieldHole fieldHole={boundary} key={index} fieldHoleDisabled={true} opacity={0.4} />
        ))}
      ;
    </>
  );
};

const connector = connect(mapStoreToProps);
export default memo(connector(SplitField));
